import { isSameDay } from 'date-fns';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';
import { WeekDays } from 'shared/types/week-days';

import { getFrequencyTimeframeCompletions } from './get-frequency-timeframe-completions';

export type Options = {
  weekStartsOn: WeekDays;
  fullyCompleted?: boolean;
  hasCompletionOnDate?: boolean;
};

export const getScheduleCompletedOnDate = (
  schedule: HabitSchedule,
  date: Timestamp,
  { weekStartsOn, fullyCompleted, hasCompletionOnDate }: Options,
) => {
  const completedOnDay = schedule.entries?.find(
    (entry) =>
      entry.state === 'complete' &&
      !!entry.value &&
      isSameDay(entry.date, date),
  );

  if (schedule.frequency) {
    const { completionsCount, target } = getFrequencyTimeframeCompletions(
      schedule,
      { referenceDate: date, weekStartsOn },
    );

    return hasCompletionOnDate
      ? !!completedOnDay && (!fullyCompleted || completionsCount >= target)
      : (!fullyCompleted && !!completionsCount) || completionsCount >= target;
  }

  return (
    !!completedOnDay &&
    (!fullyCompleted ||
      (completedOnDay.value ?? 0) >= schedule.completionTarget.count)
  );
};
